<template>
  <div>

    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Procesos" key="1">
        <g-master name="Procesos"
                  :endpoint="ProcMaster.endpoint"
                  :tableSetup="ProcMaster.tableSetup"
                  :modalFieldsSetup="ProcMaster.modalFieldsSetup"
                  :parentData="evParentData"
                  @action="masterAction"
                  @params="paramsTableProceso"
                  ref="cocMaster"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="proceso.endpointExcel" :params="paramsExcelProceso"
                         :fileName="proceso.fileNameExcel"/>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <g-dropdown endpoint="company"
                        :label="$t('Compañía')"
                        :formItemConfig="fiOptions"
                        :decorator="['company', { rules: [{ required: true, message: 'Valor requerido' }] }]"
            >
            </g-dropdown>

            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Proceso')"
                        :formItemConfig="fiOptions"
                        :decorator="['prc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        :params="proceso_request">
            </g-dropdown>


            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de pago')"
                        :formItemConfig="fiOptions"
                        :decorator="['tpay', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        :params="id_h_param_type">
            </g-dropdown>
            <a-form-item v-bind="fiOptions" :label="$t('Fliq')">
              <a-input
                v-decorator="['fliq', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
            <a-form-item v-bind="fiOptions" :label="$t('Oliq')">
              <a-input
                v-decorator="['oliq', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>

          </template>
        </g-master>
      </a-tab-pane>
      <a-tab-pane tab="Asignación de grupos" key="2">
        <g-master name="Grupos"
                  :endpoint="GroupMaster.endpoint"
                  :tableSetup="GroupMaster.tableSetup"
                  :modalFieldsSetup="GroupMaster.modalFieldsSetup"
                  :parentData="evParentData"
                  @params="paramsTableGrupo"
                  ref="grupoMaster"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="asigGrupo.endpointExcel" :params="paramsExcelAsigGrupo"
                         :fileName="proceso.fileNameExcel"/>
          </template>
          <template slot="masterModal" slot-scope="{record}">

            <g-dropdown endpoint="company"
                        :label="$t('Compañía')"
                        :formItemConfig="fiOptions"
                        :decorator="['company', { rules: [{ required: true, message: 'Valor requerido' }] }]"
            >
            </g-dropdown>

            <g-dropdown endpoint="groupmaster"
                        :label="$t('Grupo máster')"
                        :selectedObj.sync="grupoSeleccionado"
                        :formItemConfig="fiOptions"
                        :decorator="['group_id', { rules: [{ required: true, message: 'Valor requerido' }] }]"
            >
            </g-dropdown>

            <a-form-item v-bind="fiOptions" label="Descripción: ">
              <a-input
                v-decorator="['group_desc', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>

            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de pago')"
                        :formItemConfig="fiOptions"
                        :decorator="['type_pay', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                        :params="id_h_param_type">
            </g-dropdown>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        proceso: {
          paramsT: {},
          endpointExcel: 'cocproc_/downloadExcel',
          fileNameExcel: 'Procesos'
        },
        asigGrupo: {
          paramsT: {},
          endpointExcel: 'group_/downloadExcel',
          fileNameExcel: 'AsignacionGrupos'
        },
        proceso_request: {
          h_lookup_type: 'PROCESOS_LIQUIDACION',
          use_code: true,
          concat_text_code: true
        },
        id_h_param_type: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        grupoSeleccionado: {},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        ProcMaster: {
          endpoint: 'cocproc',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'customDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tipo de pago', dataIndex: 'tpay', sorter: true},
              {title: 'Proceso', dataIndex: 'prc', sorter: true},
              {title: 'Fliq', dataIndex: 'fliq', sorter: true},
              {title: 'Oliq', dataIndex: 'oliq', sorter: true},
              {title: 'Compañía', dataIndex: 'company_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'tpay'},
            {name: 'fliq'},
            {name: 'oliq'},
            {name: 'company'},
            {name: 'prc'}
          ]
        },

        GroupMaster: {
          endpoint: 'groups',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID Grupo', dataIndex: 'group_id', sorter: true},
              {title: 'Grupo', dataIndex: 'description_desc', sorter: true},
              {title: 'ID Compañía', dataIndex: 'company', sorter: true},
              {title: 'Compañía', dataIndex: 'name_desc', sorter: true},
              {title: 'Descripción', dataIndex: 'group_desc', sorter: true},
              {title: 'Tipo de pago', dataIndex: 'type_pay', sorter: true}
            ]
          },

          modalFieldsSetup: [
            {name: 'company'},
            {name: 'type_pay'},
            {name: 'group_id'},
            {name: 'group_desc'}
          ]
        }
      }
    },
    props: ['id_coc'],
    computed: {
      evParentData () {
        return {
          id_coc: this.id_coc
        }
      },
      paramsExcelProceso () {
        return {
          ...this.proceso.paramsT,
          ...this.evParentData,
          columns: this.ProcMaster.tableSetup.columns
        }
      },
      paramsExcelAsigGrupo () {
        return {
          ...this.asigGrupo.paramsT,
          ...this.evParentData,
          columns: this.GroupMaster.tableSetup.columns
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    watch: {
      grupoSeleccionado () {
        this.$refs.grupoMaster.modal.form.setFieldsValue({
          group_desc: this.grupoSeleccionado.description
        })
      }
    },
    methods: {
      paramsTableProceso (params) {
        this.proceso.paramsT = params
      },
      paramsTableGrupo (params) {
        this.asigGrupo.paramsT = params
      },
      masterAction (action) {
        switch (action.action) {
          case 'customDelete':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('cocproc/rnd', {
                    data: action.record
                  })
                    .then(() => {
                      this.$refs.cocMaster.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Coc/AsigYProc.vue